import { GCW_Container, grandChartWindowVariants } from "./GrandChartWindow.styled";
import { observer } from "mobx-react";
import { useStores } from "../../../../stores";
import { Header } from "./Header";
import { GrandChartBody } from "./GrandChartBody";

interface GrandChartWindowProps {}

export const GrandChartWindow = observer(({}: GrandChartWindowProps) => {
	const { grandCharts } = useStores();
	const { selected } = grandCharts;

	return (
		<GCW_Container
			$service={selected.service.slug}
			$modulesCount={selected.grand_chart_modules.length}
			$coursesCount={selected.grand_chart_courses.length}
			initial="hidden"
			animate="visible"
			exit="exit"
			variants={grandChartWindowVariants}
		>
			<Header />
			<GrandChartBody />
		</GCW_Container>
	);
});
